import { Colors } from '@/common/colors/colors';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Input from '@/common/components/Input';
import Loading from '@/common/components/Loading';
import PopUp from '@/common/components/PopUp';
import SelectInput from '@/common/components/SelectInput';
import { DOCUMENT_OPTIONS } from '../../constants/documentOptions';
import useDocsPopUp from '../../hooks/useDocsPopUp';
import { Form, Header } from './PopUp.styled';

export default function DocsPopUp({ setShow, handleSubmit }) {
	const hook = useDocsPopUp({ setShow, handleSubmit });

	return (
		<>
			{hook.isLoading && <Loading />}
			<PopUp setShow={setShow}>
				<Header>Send documents</Header>
				<Form onSubmit={hook.onSubmit}>
					<SelectInput
						options={hook.fileOptions}
						color={Colors.darkBlue}
						name='Attachments'
						setSelected={(value) => hook.setSelectedAttachments(value)}
						selected={hook.selectedAttachments}
						type='number'
						width={200}
						multiple
					/>
					<SelectInput
						options={DOCUMENT_OPTIONS}
						color={Colors.darkBlue}
						name='Documents'
						setSelected={(value) => hook.setSelectedDocuments(value)}
						selected={hook.selectedDocuments}
						type='number'
						width={200}
						multiple
					/>
					<Input
						name='Start Date'
						width={100}
						color={Colors.darkBlue}
						inputRef={hook.startDateRef}
						type='date'
						inputWidth={160}
						required
					/>
					<Input
						name='Deadline'
						width={100}
						color={Colors.darkBlue}
						inputRef={hook.deadlineRef}
						type='date'
						inputWidth={160}
						required
					/>
					<Input
						name='Include questionnaire paragraph'
						width={200}
						type='checkbox'
						color={Colors.darkBlue}
						height={20}
						inputWidth={260}
						onChange={() =>
							hook.setIncludeQuestionnaireParagraph((prev) => !prev)
						}
						isChecked={hook.includeQuestionnaireParagraph}
					/>
					<SubmitButton text='Send email' color={Colors.darkBlue} />
				</Form>
			</PopUp>
		</>
	);
}
